import React from 'react';
import styles from './ExportComponent.module.css';
import 'xlsx';

const ExportComponent = ({ tableRef }) => {
  const onExport = (type) => {
    if (tableRef.current) {
      switch (type) {
        case 'excel':
          tableRef.current.download('xlsx', 'data.xlsx', {
            sheetName: 'MyData',
          });
          break;
        case 'html':
          tableRef.current.download('html', 'data.html');
          break;
        case 'pdf':
          tableRef.current.download('pdf', 'data.pdf', {
            orientation: 'portrait',
            title: 'Data Export',
          });
          break;
        default:
          console.warn('Unknown export type');
      }
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.exportButton} onClick={() => onExport('excel')}>
        <i className="fas fa-file-excel" />
        <span className={styles.text}>Excel</span>
      </div>
      {/* <div className={styles.exportButton} onClick={() => onExport('html')}>
        <i className="fas fa-file-code" />
        <span className={styles.text}>HTML</span>
      </div> */}
      {/* <div className={styles.exportButton} onClick={() => onExport("pdf")}>
        Export to PDF
      </div> */}
    </div>
  );
};

export default ExportComponent;
